"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("../../utils/type-checks/function");
var _string = require("../../utils/type-checks/string");
var _formSerialize = _interopRequireDefault(require("form-serialize"));
var _excluded = ["className", "children", "onSubmit", "serializeIncludeDisabled", "serializeIncludeEmpty", "serializeOnSubmit", "serializeToObject"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Form = function Form(props) {
  var className = props.className,
    children = props.children,
    onSubmit = props.onSubmit,
    serializeIncludeDisabled = props.serializeIncludeDisabled,
    serializeIncludeEmpty = props.serializeIncludeEmpty,
    serializeOnSubmit = props.serializeOnSubmit,
    serializeToObject = props.serializeToObject,
    rest = _objectWithoutProperties(props, _excluded);
  var cmpClassName = (0, _classnames.default)(_defineProperty({
    "cmp-form": true
  }, className, (0, _string.isStringOfLength)(className)));
  var handleSubmit = null;
  if ((0, _function.isFunction)(onSubmit)) {
    if (serializeOnSubmit) {
      handleSubmit = function handleSubmit(e) {
        var formData = (0, _formSerialize.default)(e.target, {
          disabled: serializeIncludeDisabled,
          empty: serializeIncludeEmpty,
          hash: serializeToObject
        });
        onSubmit(e, formData);
        (0, _function.isFunction)(e.preventDefault) && e.preventDefault();
        (0, _function.isFunction)(e.stopPropagation) && e.stopPropagation();
      };
    } else {
      handleSubmit = function handleSubmit(e) {
        onSubmit(e);
        (0, _function.isFunction)(e.preventDefault) && e.preventDefault();
        (0, _function.isFunction)(e.stopPropagation) && e.stopPropagation();
      };
    }
  }
  return /*#__PURE__*/_react.default.createElement("form", _extends({}, rest, {
    className: cmpClassName,
    onSubmit: handleSubmit
  }), children);
};

// Define propTypes;
Form.propTypes = {
  /** Child node or nodes */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),
  /** String to be added to className */
  className: _propTypes.default.string,
  /** Function to capture and replace default submit event */
  onSubmit: _propTypes.default.func,
  /** Flag to include disabled fields during serialization */
  serializeIncludeDisabled: _propTypes.default.bool,
  /** Flag to include empty fields during serialization */
  serializeIncludeEmpty: _propTypes.default.bool,
  /** Flag to serialize form data to string 'key=value' on submit event */
  serializeOnSubmit: _propTypes.default.bool,
  /** Flag to serialize form data to an object '{ key: "value" }' on submit event */
  serializeToObject: _propTypes.default.bool
};

// Define defaultProps;
Form.defaultProps = {
  serializeIncludeDisabled: false,
  serializeIncludeEmpty: false,
  serializeOnSubmit: true,
  serializeToObject: true
};

// Export component as default;
var _default = exports.default = Form;